import { render } from "./BankAccessConfig.vue?vue&type=template&id=036b2dfb&scoped=true"
import script from "./BankAccessConfig.vue?vue&type=script&lang=js"
export * from "./BankAccessConfig.vue?vue&type=script&lang=js"

import "./BankAccessConfig.vue?vue&type=style&index=0&id=036b2dfb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036b2dfb"]])

export default __exports__